__webpack_require__.p = "https://dev-iux-svg-webtrade.iuxbeta.com/";